"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoMatChaveModeloCentroTrabalho = void 0;
var TipoMatChaveModeloCentroTrabalho = /** @class */ (function () {
    function TipoMatChaveModeloCentroTrabalho(_a) {
        var _b = _a._id, _id = _b === void 0 ? { TIPO_MAT: '', CHAVE_MODELO: '', CENTRO_TRAB: '' } : _b, _c = _a.TIPO_MAT, TIPO_MAT = _c === void 0 ? '' : _c, _d = _a.CHAVE_MODELO, CHAVE_MODELO = _d === void 0 ? '' : _d, _e = _a.CENTRO_TRAB, CENTRO_TRAB = _e === void 0 ? '' : _e;
        this._id = _id;
        this.TIPO_MAT = TIPO_MAT;
        this.CHAVE_MODELO = CHAVE_MODELO;
        this.CENTRO_TRAB = CENTRO_TRAB;
    }
    return TipoMatChaveModeloCentroTrabalho;
}());
exports.TipoMatChaveModeloCentroTrabalho = TipoMatChaveModeloCentroTrabalho;
//# sourceMappingURL=TipoMatChaveModeloCentroTrabalho.js.map